import { Arrange, Skeleton, Box, Columns, Column } from "@aviary";
import { Size } from "@shared/types/sizes";

const SkeletonProductActions = () => {
  return (
    <Arrange isVertical isFullWidth spacing="large">
      <Arrange isVertical isFullWidth>
        <Columns preserveMobileColumns isMarginless>
          <Column columnWidth={6} isPaddingless>
            <Arrange spacing="xsmall" isVertical>
              <Skeleton type="typography" />
              <Skeleton type="button" />
            </Arrange>
          </Column>
          <Column columnWidth={6} isPaddingless>
            <Arrange spacing="xsmall" isVertical>
              <Skeleton type="typography" />
              <Skeleton type="button" />
            </Arrange>
          </Column>
        </Columns>
        <Arrange isVertical isFullWidth spacing="xsmall">
          <Skeleton type="typography" isFullWidth />
          <Skeleton type="button" buttonSize={Size.LARGE} isFullWidth />
        </Arrange>
      </Arrange>

      <Skeleton type="typography" isFullWidth />
      <Box isBordered padding="xxsmall">
        <Skeleton type="typography" isFullWidth />
      </Box>
    </Arrange>
  );
};

export { SkeletonProductActions };
